export default "__VITE_PUBLIC_ASSET__c7af520b__"